<template>
  <div
    :class="{
      'app-grid-container': !disabled,
      'one-column': !disabled && oneColumn,
      'hide-left-column': hideLeftColumn
    }"
  >
    <nav v-if="!hideLeftColumn" class="left-column">
      <slot name="left" />
    </nav>
    <section class="top">
      <slot name="above-content" />
    </section>
    <section class="content">
      <slot name="content" />
    </section>
    <section v-if="!oneColumn" class="content-secondary">
      <slot name="content-secondary" />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    oneColumn: {
      type: Boolean,
      default: false
    },
    hideLeftColumn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-grid-container {
  --side-min-width: 226px;
  --side-max-width: 398px;
  --content-min-width: 500px;
  --app-content-max-width: 812px;

  --side-min-max: minmax(var(--side-min-width), var(--side-max-width));
  --content-min-max: minmax(var(--content-min-width), var(--app-content-max-width));

  gap: 0px 16px;
  width: 100vw;
  max-width: min(var(--app-container-width), calc(100vw - 88px));
  height: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-areas:
    "nav top     top"
    "nav content secondary";
  grid-template-rows: auto 1fr;
  grid-template-columns: var(--side-min-max) var(--content-min-max) var(--side-min-max);

  .left-column {
    grid-area: nav;
  }

  &.hide-left-column {
    grid-template-areas:
      "top top"
      "content secondary";
    grid-template-columns: var(--content-min-max) var(--side-min-max);
  }

  .top {
    grid-area: top;
  }

  .content {
    grid-area: content;
  }

  .content-secondary {
    grid-area: secondary;
  }

  .left-column,
  .top,
  .content,
  .content-secondary {
    padding: 0 4px;
  }

  .left-column,
  .content-secondary {
    position: sticky;
    top: var(--desktop-top-bar-height);
    max-height: calc(100vh - var(--desktop-top-bar-height));
    min-width: var(--side-min-width);
    max-width: var(--side-max-width);
    overflow-y: auto;
  }

  &.one-column {
    grid-template-areas:
      "nav top top"
      "nav content content";
  }
}
</style>
